import { Router } from 'app/classes';

export class SubscriptionWarningController implements ng.IController {

    public static $inject = [
        '$scope',
        '$document',
        'close',
        'acctServMessage',
        'phone',
        'status'
    ];

    public modalHeader: string;
    public modalIcon: string;

    constructor(private $scope,
                private $document,
                public close,
                public acctServMessage: string,
                public phone: string,
                public status: string
    ) {

        this.setModalHeader();
        this.setIcon();

        $document.on('keydown', this.escHandler);

        $scope.$on('$destroy', () => {
            $document.off('keydown', this.escHandler);
        });
    }

    public escHandler = (event) => {
        if (event.keyCode === 27) {
            this.close();
        }
    }

    private setModalHeader = () => {
        if (this.status === 'suspended') {
            this.modalHeader = 'cp.appPlatform.acctSuspended';
        } else if (this.status === 'seasonal-hold') {
            this.modalHeader = 'cp.appPlatform.acctSeasonalHold';
        }
    }
    private setIcon = () => {
        if (this.status === 'suspended') {
            this.modalIcon = 'fa-ban';
        } else if (this.status === 'seasonal-hold') {
            this.modalIcon = 'fa-hand-paper-o';
        }
    }
}
